import * as React from "react";
export var HomeProductsContext = React.createContext({
  data: null,
  loading: true
});
HomeProductsContext.displayName = "HomeProductsContext";